import { render, staticRenderFns } from "./returnReviewOpinion.vue?vue&type=template&id=f65bfd96&"
import script from "./returnReviewOpinion.vue?vue&type=script&lang=js&"
export * from "./returnReviewOpinion.vue?vue&type=script&lang=js&"
import style0 from "./returnReviewOpinion.vue?vue&type=style&index=0&id=f65bfd96&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports